import React, {useEffect} from 'react';
import {loadTimelineData} from 'anima-timeline';
import "./BlogDetailPage.css";
import NavBar from "../NavBar";
import Footer from "../Footer";
import ReplyForm from '../../Common/BlogReply';
import {blog_detail} from "../../data";



function App() {
  return <X09BlogsDetailsPageTablet {...x09BlogsDetailsPageTabletData} />;
}

export default App;

function X09BlogsDetailsPageTablet(props) {
  const {
    text314,
    rectangle76,
    address,
    text317,
    rectangle97,
    rectangle98,
    followUs,
    line56,
    ellipse105,
    spanText,
    spanText2,
    text319,
    line57,
    leaveAReply,
    frame144Props,
    facebookAppSymbolProps,
    instagram2Props,
    twitterProps,
    textInputsNormal20Props,
    frame1650Props,
    textInputsNormal22Props,
    button11Props,
    //footer52Props,
  } = props;

  return (
    <div className="bdpt-container-center-horizontal">
      <div className="bdpt-x09-blogs-details-page-tablet screen">
        {/* <Frame144 group86Props={frame144Props.group86Props} iconMenuProps={frame144Props.iconMenuProps} /> */}
        <NavBar/>
        <h1 className="bdpt-text-1 bdpt-valign-text-middle bdpt-typographyheadlineh4-extrabold-24">{text314}</h1>
        {/* <img className="bdpt-rectangle-76" src={rectangle76} /> */}
        <img className="bdpt-rectangle-76" src={blog_detail.BlogDetailHeader} />
        <div className="bdpt-group-196">
          <div className="bdpt-address bdpt-valign-text-middle bdpt-typography-body-smalltext-14-regular">{address}</div>
          <p className="bdpt-text-4 bdpt-typography-body-smalltext-14-regular">{text317}</p>
        </div>
        <div className="bdpt-frame-1636">
          <div className="bdpt-frame-1644">
            {/* <img className="bdpt-rectangle-97" src={rectangle97} /> */}
            <img className="bdpt-rectangle-97" src={blog_detail.BlogDetailCard1} />

            {/* <img className="bdpt-rectangle-98" src={rectangle98} /> */}
            <img className="bdpt-rectangle-98" src={blog_detail.BlogDetailCard2} />
          </div>
          <div className="bdpt-frame-1645">
            <div className="bdpt-follow-us bdpt-valign-text-middle bdpt-typographybody16-regular">{followUs}</div>
            <div className="bdpt-frame-1561">
              <FacebookAppSymbol src={facebookAppSymbolProps.src} />
              <Instagram2 overlapGroup1={instagram2Props.overlapGroup1} vector2={instagram2Props.vector2} />
              <Twitter src={twitterProps.src} />
            </div>
          </div>
        </div>
        <div className="bdpt-frame-200">
          <img className="bdpt-line-56" src={line56} />
          <div className="bdpt-frame-1646">
            {/* <img className="bdpt-ellipse-105" src={ellipse105} /> */}
            <img className="bdpt-ellipse-105" src={blog_detail.BlogDetailWriter} />
            <div className="bdpt-frame-199">
              <div className="bdpt-text-5 bdpt-valign-text-middle bdpt-typographyheadlineh5-extrabold-20">
                <span>
                  <span className="bdpt-span0 bdpt-typographyheadlineh5-extrabold-20">{spanText}</span>
                  <span className="bdpt-span1 bdpt-typographyheadlineh5-extrabold-20">{spanText2}</span>
                </span>
              </div>
              <p className="bdpt-text-6 bdpt-typographybodysmall-12-regular">{text319}</p>
            </div>
          </div>
          <img className="bdpt-line-57" src={line57} />
        </div>
        <div className="bdpt-frame-1649">
          <div className="bdpt-leave-a-reply bdpt-valign-text-middle bdpt-typographyheadlineh4-extrabold-24">{leaveAReply}</div>
          <ReplyForm />
          {/* <div className="bdpt-frame-1648">
            <TextInputsNormal20>{textInputsNormal20Props.children}</TextInputsNormal20>
            <div className="bdpt-frame-1647">
              <Frame1650
                textInputsNormal2Props={frame1650Props.textInputsNormal2Props}
                textInputsNormal22Props={frame1650Props.textInputsNormal22Props}
              />
              <TextInputsNormal22 className={textInputsNormal22Props.className}>
                {textInputsNormal22Props.children}
              </TextInputsNormal22>
            </div>
          </div>
          <Button11>{button11Props.children}</Button11> */}
        </div>
        {/* <Footer52 {...footer52Props} /> */}
        <Footer />
      </div>
      
    </div>
  );
}


function Frame144(props) {
  const { group86Props, iconMenuProps } = props;

  return (
    <div className="bdpt-frame-144">
      <Group86 group85={group86Props.group85} whiteProps={group86Props.whiteProps} />
      <IconMenu vector2={iconMenuProps.vector2} vector3={iconMenuProps.vector3} />
    </div>
  );
}


function Group86(props) {
  const { group85, whiteProps } = props;

  return (
    <div className="bdpt-group-86">
      <White src={whiteProps.src} />
      <img className="bdpt-group-85" src={group85} />
    </div>
  );
}


function White(props) {
  const { src } = props;

  return (
    <div className="bdpt-white">
      <img className="bdpt-vector" src={src} />
    </div>
  );
}


function IconMenu(props) {
  const { vector2, vector3 } = props;

  return (
    <div className="bdpt-icon-menu">
      <img
        className="bdpt-vector-2"
        src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg"
      />
      <img className="bdpt-vector-1" src={vector2} />
      <img className="bdpt-vector-1" src={vector3} />
    </div>
  );
}


function FacebookAppSymbol(props) {
  const { src } = props;

  return (
    <div className="bdpt-facebook-app-symbol">
      <img className="bdpt-f-1" src={src} />
    </div>
  );
}


function Instagram2(props) {
  const { overlapGroup1, vector2, className } = props;

  return (
    <div className={`bdpt-instagram ${className || ""}`}>
      <div className="bdpt-overlap-group" style={{ backgroundImage: `url(${overlapGroup1})` }}>
        <img
          className="bdpt-vector-3"
          src="/Images/Blogs_detail/instagram2.svg"
        />
        <img className="bdpt-vector-4" src={vector2} />
      </div>
    </div>
  );
}


function Twitter(props) {
  const { src, className } = props;

  return (
    <div className={`bdpt-twitter ${className || ""}`}>
      <img className="bdpt-vector-5" src={src} />
    </div>
  );
}


function TextInputsNormal20(props) {
  const { children } = props;

  return (
    <div className="bdpt-text-inputs-normal">
      <div className="bdpt-frame-1 bdpt-border-1px-light-grey">
        <div className="bdpt-text-i27326713671 bdpt-inter-normal-sonic-silver-14px">{children}</div>
      </div>
    </div>
  );
}


function Frame1650(props) {
  const { textInputsNormal2Props, textInputsNormal22Props } = props;

  return (
    <div className="bdpt-frame-1650">
      <TextInputsNormal22>{textInputsNormal2Props.children}</TextInputsNormal22>
      <TextInputsNormal22 className={textInputsNormal22Props.className}>
        {textInputsNormal22Props.children}
      </TextInputsNormal22>
    </div>
  );
}


function TextInputsNormal22(props) {
  const { children, className } = props;

  return (
    <div className={`bdpt-text-inputs-normal-1 ${className || ""}`}>
      <div className="bdpt-frame-1-1 bdpt-border-1px-light-grey">
        <div className="bdpt-text-i27326716671 bdpt-inter-normal-sonic-silver-14px">{children}</div>
      </div>
    </div>
  );
}


function Button11(props) {
  const { children } = props;

  useEffect(() => {
    loadTimelineData(x27326733TimelineData);
  }, []);

  return (
    <div className="bdpt-x27326733 bdpt-component bdpt-component-wrapper not-ready">
      <div className="bdpt-master-button-ISwYQp">
        <div className="bdpt-button-i2732673351-s1UvEd bdpt-valign-text-middle">{children}</div>
      </div>
    </div>
  );
}

const x27326733TimelineData = [
  {
    initial_state_name: "Property-1=Primary",
    root_element: ".bdpt-x27326733",
    states_flow: {
      "Property-1=Primary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Secondary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Tertiary": {
        listeners: [],
        overrides: {},
      },
    },
  },
];


// function Footer52(props) {
//   const {
//     group85,
//     place,
//     overlapGroup,
//     vector2,
//     phone,
//     overlapGroup1,
//     vector3,
//     text15,
//     text14,
//     contactWebuildCom,
//     quickLinks,
//     aboutUs,
//     projects,
//     gallery,
//     knowledgeTransfer,
//     blogs,
//     faqs,
//     group872Props,
//   } = props;

//   return (
//     <div className="bdpt-footer">
//       <div className="bdpt-flex-row-1">
//         <img
//           className="bdpt-vector-6"
//           src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-148@2x.svg"
//         />
//         <img className="bdpt-group-85-1" src={group85} />
//         <Group872
//           facebookAppSymbolProps={group872Props.facebookAppSymbolProps}
//           facebookAppSymbolProps2={group872Props.facebookAppSymbolProps2}
//           twitterProps={group872Props.twitterProps}
//         />
//       </div>
//       <div className="bdpt-flex-row-2">
//         <div className="bdpt-group-32">
//           <div className="bdpt-place bdpt-valign-text-middle bdpt-typographyheadlineh5-extrabold-20">{place}</div>
//           <div className="bdpt-flex-row-3">
//             <div className="bdpt-flex-col">
//               <div className="bdpt-map-pin-1">
//                 <div className="bdpt-overlap-group-1" style={{ backgroundImage: `url(${overlapGroup})` }}>
//                   <img className="bdpt-vector-7" src={vector2} />
//                 </div>
//               </div>
//               <div className="bdpt-phone" style={{ backgroundImage: `url(${phone})` }}></div>
//               <div className="bdpt-mail">
//                 <div className="bdpt-overlap-group1" style={{ backgroundImage: `url(${overlapGroup1})` }}>
//                   <img className="bdpt-vector-8" src={vector3} />
//                 </div>
//               </div>
//             </div>
//             <div className="bdpt-flex-col-1">
//               <p className="bdpt-text-3 bdpt-typography-body-smalltext-14-regular">{text15}</p>
//               <div className="bdpt-flex-col-item bdpt-valign-text-middle bdpt-typography-body-smalltext-14-regular">{text14}</div>
//               <div className="bdpt-flex-col-item bdpt-valign-text-middle bdpt-typography-body-smalltext-14-regular">
//                 {contactWebuildCom}
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="bdpt-group-147">
//           <div className="bdpt-quick-links bdpt-valign-text-middle bdpt-typographyheadlineh5-extrabold-20">{quickLinks}</div>
//           <div className="bdpt-flex-row-4">
//             <div className="bdpt-about-us bdpt-valign-text-middle bdpt-typographybody16-regular">{aboutUs}</div>
//             <div className="bdpt-projects bdpt-valign-text-middle bdpt-typographybody16-regular">{projects}</div>
//           </div>
//           <div className="bdpt-flex-row">
//             <div className="bdpt-gallery bdpt-valign-text-middle bdpt-typographybody16-regular">{gallery}</div>
//             <div className="bdpt-knowledge-transfer bdpt-valign-text-middle bdpt-typographybody16-regular">{knowledgeTransfer}</div>
//           </div>
//           <div className="bdpt-flex-row">
//             <div className="bdpt-blogs bdpt-valign-text-middle bdpt-typographybody16-regular">{blogs}</div>
//             <div className="bdpt-fa-qs bdpt-valign-text-middle bdpt-typographybody16-regular">{faqs}</div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }


function Group872(props) {
  const { facebookAppSymbolProps, facebookAppSymbolProps2, twitterProps } = props;

  return (
    <div className="bdpt-group-87">
      <FacebookAppSymbol src={facebookAppSymbolProps.src} />
      <Instagram2
        overlapGroup1={facebookAppSymbolProps2.overlapGroup1}
        vector2={facebookAppSymbolProps2.vector2}
        className={facebookAppSymbolProps2.className}
      />
      <Twitter src={twitterProps.src} className={twitterProps.className} />
    </div>
  );
}

const whiteData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-98@2x.svg",
};

const group86Data = {
    group85: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/group-85@2x.svg",
    whiteProps: whiteData,
};

const iconMenuData = {
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
    vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
};

const frame144Data = {
    group86Props: group86Data,
    iconMenuProps: iconMenuData,
};

const facebookAppSymbolData = {
    src: "/Images/Blogs_detail/facebook.svg",
};

const instagram2Data = {
    overlapGroup1: "/Images/Blogs_detail/instagram1.svg",
    vector2: "/Images/Blogs_detail/instagram3.svg",
};

const twitterData = {
    src: "/Images/Blogs_detail/twiter.svg",
};

const textInputsNormal20Data = {
    children: "Comment",
};

const textInputsNormal22Data = {
    children: "Name",
};

const textInputsNormal222Data = {
    children: "Email",
    className: "bdpt-text-inputs-normal-2",
};

const frame1650Data = {
    textInputsNormal2Props: textInputsNormal22Data,
    textInputsNormal22Props: textInputsNormal222Data,
};

const textInputsNormal223Data = {
    children: "Phone Number",
    className: "bdpt-text-inputs-normal-3",
};

const button11Data = {
    children: "POST COMMENT",
};

const facebookAppSymbol2Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/f-1-1@2x.svg",
};

const instagram22Data = {
    overlapGroup1: "/Images/Blogs_detail/instagram3.svg",
    vector2: "/Images/Blogs_detail/instagram2.svg",
    className: "bdpt-instagram-1",
};

const twitter2Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-157@2x.svg",
    className: "bdpt-twitter-1",
};

const group872Data = {
    facebookAppSymbolProps: facebookAppSymbol2Data,
    facebookAppSymbolProps2: instagram22Data,
    twitterProps: twitter2Data,
};

// const footer52Data = {
//     group85: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/group-85-25@2x.svg",
//     place: "Contact",
//     overlapGroup: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-20@2x.svg",
//     vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-21@2x.svg",
//     phone: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-212@2x.svg",
//     overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-231@2x.svg",
//     vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-232@2x.svg",
//     text15: "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint.",
//     text14: "+91 8976535221, +91 8755645342",
//     contactWebuildCom: "contact@webuild.com",
//     quickLinks: "Quick Links",
//     aboutUs: "About Us",
//     projects: "Projects",
//     gallery: "Gallery",
//     knowledgeTransfer: "Knowledge Transfer",
//     blogs: "Blogs",
//     faqs: "FAQ’s",
//     group872Props: group872Data,
// };

const x09BlogsDetailsPageTabletData = {
    text314: "Lorem Ipsum passages of Lorem Ipsum available",
    rectangle76: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-76-9@1x.png",
    address: "5 June 2021",
    text317: <>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer quis sapien ac massa dapibus lacinia. Nunc et cursus quam. Cras pharetra condimentum leo, ac tincidunt sem pharetra nec. Nunc faucibus ipsum vel metus aliquam, bdpt-interdum feugiat massa viverra. Donec velit magna, sodales sed convallis eu, egestas vel nisl. Etiam fermentum felis ac risus scelerisque, ac euismod diam finibus. Suspendisse lacus sem, gravida vestibulum ligula et, pulvinar mattis purus.<br /><br />Etiam fermentum felis ac risus scelerisque, ac euismod diam finibus. Suspendisse lacus sem, gravida vestibulum ligula et, pulvinar mattis purus. Phasellus mollis molestie ante sed rhoncus.<br /><br />Sed eu faucibus libero. Nunc at libero eget massa lobortis consectetur vel eu ligula. Suspendisse est mauris, fermentum id pellentesque ut, pharetra quis risus. Aliquam placerat orci turpis, quis venenatis massa lobortis a. Integer nec magna erat. Nullam vel dui vel purus consequat fermentum. Donec rhoncus convallis erat sit amet vestibulum. Duis lacinia, purus eget fermentum volutpat, justo ipsum mattis risus, a efficitur sapien nisi nec augue.</>,
    rectangle97: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-97-2@2x.png",
    rectangle98: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-98-2@2x.png",
    followUs: "Share:",
    line56: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-56-2@1x.svg",
    ellipse105: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/ellipse-105@2x.png",
    spanText: "Written by:",
    spanText2: " Darlene Robertson",
    text319: "Donec vitae mi metus. Vestibulum ac aliquam ligula. Sed vestibulum eu mi in finibus. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.",
    line57: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-56-2@1x.svg",
    leaveAReply: "Leave a reply",
    frame144Props: frame144Data,
    facebookAppSymbolProps: facebookAppSymbolData,
    instagram2Props: instagram2Data,
    twitterProps: twitterData,
    textInputsNormal20Props: textInputsNormal20Data,
    frame1650Props: frame1650Data,
    textInputsNormal22Props: textInputsNormal223Data,
    button11Props: button11Data,
    //footer52Props: footer52Data,
};

